import React from 'react'
import Breadcrumbs from '../components/Breadcrumbs'
import Headers from '../components/Headers';

function Volunteer(props) {
  const link = props.linksDs.find(link => link.link === '/volunteer');
  const pageTitle = props.lang === 'en' ? link.name_en : link.name_se;
  return (
    <>
      <Headers title={pageTitle} lang={props.lang} clink='/volunteer' />
      <Breadcrumbs title={pageTitle} lang={props.lang} bgimg="https://mhs.mharis.info/wp-content/uploads/2023/04/bg-volunteer-act-banner.jpg" />
      <div>Volunteer</div>
    </>

  )
}

export default Volunteer
